import { ApiGetRequest, EAibGrid, ECertificateDocumentType, ECertificateType, ETypeOfSupport } from 'types';

export enum EEecsProductModals {
  ADD_EDIT = 'add_edit',
  CONFIRM = 'confirm',
  DETAILS = 'details',
}

export enum EEecsProductModalAction {
  DELETE = 'delete',
}

export interface EecsProductModalPayload {
  action?: EEecsProductModalAction;
}

export interface IEecsProductModal {
  type: EEecsProductModals;
  payload?: EecsProductModalPayload;
}

export interface IEecsProduct {
  id: number;
  name: string;
  type: ECertificateType;
  is_active: boolean;
  type_of_installations: {
    code: string;
    path: string[];
  }[];
  energy_sources: {
    code: string;
    path: string[];
  }[];
  aib_grid_connected: EAibGrid;
  production_year: string;
  type_of_support: ETypeOfSupport;
  operational_year_start: string | null;
  operational_year_end: string | null;
  certifications: ECertificateDocumentType[] | null;
  country_of_issue_codes: string[] | null;
  production_period_start: string | null;
  production_period_end: string | null;
  position_index: number;
}

export interface FetchEecsProductsPayload extends ApiGetRequest {
  filter_by_is_active?: boolean | null;
}

export interface CreateEecsProductPayload {
  name: string;
  type: ECertificateType;
  is_active: boolean;
  type_of_installations: string[];
  energy_sources: string[];
  aib_grid_connected: EAibGrid;
  production_year: number;
  type_of_support: ETypeOfSupport;
  operational_year_start?: number | null;
  operational_year_end?: number | null;
  certifications?: string[];
  country_of_issue_codes?: string[];
  production_period_start: string | null;
  production_period_end: string | null;
}

export interface UpdateEecsProductPayload extends CreateEecsProductPayload {
  id: number;
}

export interface DeleteEecsProductPayload {
  id: number;
}

export interface SaveProductOrderPayload {
  order: {
    id: number;
    position_index: number;
  }[];
}
